import { Injectable } from '@angular/core';
import {
  BusinessReviewConfiguration,
  IClinicReviewDetails,
  IClinicV1Dropdown,
  IClinicV1Summary,
  IServiceListV1,
} from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';
import { TenantService } from '../helper-service/tenant.service';

@Injectable({
  providedIn: 'root',
})
export class ClinicService {
  constructor(
    private readonly _httpService: HttpService,
    private readonly _tenantService: TenantService
  ) {}

  public _fetchClinicDropdownByUserRole(
    view: 'list' | 'summary'
  ): Observable<IClinicV1Summary[]>;
  public _fetchClinicDropdownByUserRole(
    view: 'dropdown'
  ): Observable<IClinicV1Dropdown[]>;
  public _fetchClinicDropdownByUserRole(
    view: 'list' | 'dropdown' | 'summary' = 'dropdown'
  ): Observable<IClinicV1Dropdown[] | IClinicV1Summary[]> {
    const url = `${API_ENDPOINTS.CLINIC_ENDPOINTS.v1AllClinicsDropdown(view)}`;
    return this._httpService.get<IClinicV1Dropdown[] | IClinicV1Summary[]>(url);
  }

  public fetchServiceListByClinicId(id: number): Observable<IServiceListV1> {
    const url = API_ENDPOINTS.CLINIC_ENDPOINTS.getServicesByClinicId(id);
    return this._httpService.get<IServiceListV1>(url);
  }

  public _fetchClinicReviewDetailById(
    id: number
  ): Observable<IClinicReviewDetails> {
    const url = API_ENDPOINTS.CLINIC_ENDPOINTS.clinicReviewDetail(id);
    return this._httpService.get<IClinicReviewDetails>(url);
  }

  public _fetchBusinessReviewConfiguration(): Observable<BusinessReviewConfiguration> {
    const url = API_ENDPOINTS.CLINIC_ENDPOINTS.businessReviewConfiguration(
      this._tenantService.getBusinessId()
    );
    return this._httpService.get<BusinessReviewConfiguration>(url);
  }

  public _refreshReview(clinicId: number): Observable<any> {
    const url = API_ENDPOINTS.CLINIC_ENDPOINTS.refreshReview(clinicId);
    return this._httpService.get(url);
  }

  public _saveClinicReviewConfiguration(
    clinicId: number,
    requestBody: IClinicReviewDetails
  ): Observable<any> {
    const url =
      API_ENDPOINTS.CLINIC_ENDPOINTS.saveBusinessReviewConfiguration(clinicId);
    return this._httpService.post(url, requestBody);
  }

  public _getClinicDetail(clinicId: number) {
    const apiUrl = `${API_ENDPOINTS.CLINIC_ENDPOINTS.getClinicDetailsV1(clinicId)}`;
    return this._httpService.get<{ timezone: string }>(apiUrl);
  }
}
